document.addEventListener('DOMContentLoaded', function() {
    const swatches = document.querySelectorAll('.color-swatch-button');
    const metaWrapper = document.querySelector('.product__metaimage-wrapper');
    const metaImg = document.getElementById('metaimage-display');
    const hiddenInput = document.getElementById('selected-color-input');

    swatches.forEach(btn => {
    btn.addEventListener('click', function() {
        const metaImage = this.dataset.metaImage;
        const label = this.dataset.label || this.dataset.color; // ✅ prefer label
        
        // ✅ update hidden input value
        if (hiddenInput) {
            hiddenInput.value = label;
        }

        if (metaImage && metaWrapper && metaImg) {
        metaImg.src = metaImage;
        metaWrapper.style.display = 'block';
        }

        // Highlight selected swatch
        swatches.forEach(s => s.style.borderColor = '#ddd');
        this.style.borderColor = '#000';

        // Optional: Scroll to image if needed
        if (metaWrapper) {
        metaWrapper.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
    });

    // Show tooltip on hover/focus
    btn.addEventListener('mouseenter', function() {
        const tooltip = this.querySelector('.swatch-tooltip');
        if (tooltip) tooltip.style.opacity = '1';
    });

    btn.addEventListener('mouseleave', function() {
        const tooltip = this.querySelector('.swatch-tooltip');
        if (tooltip) tooltip.style.opacity = '0';
    });

    btn.addEventListener('focus', function() {
        const tooltip = this.querySelector('.swatch-tooltip');
        if (tooltip) tooltip.style.opacity = '1';
    });

    btn.addEventListener('blur', function() {
        const tooltip = this.querySelector('.swatch-tooltip');
        if (tooltip) tooltip.style.opacity = '0';
    });
    });
});